import React, { useState, useEffect, useRef } from "react";

import emerald from "../../assets/images/emerald.jpg";
import Roundimg from "../../assets/images/Round_65x65.jpg";
import RadiantImg from "../../assets/images/Radiant.jpg";
import PrincessImg from "../../assets/images/Princess.jpg";
import PearImg from "../../assets/images/Pear.jpg";
import OvalImg from "../../assets/images/Oval.jpg";
import MarquiseImg from "../../assets/images/Marquise.jpg";
import HeartImg from "../../assets/images/Heart.jpg";
import EmeraldImg from "../../assets/images/emerald.jpg";
import CushionImg from "../../assets/images/Cushion.jpg";
import AsscherImg from "../../assets/images/Asscher.jpg";
import ImageIcon from "../../assets/images/imageIcon.png";
import { useTranslation } from "react-i18next";
import Filter_icon from "../../assets/images/filter_icon.png";
import AppsRingBuilderService from "../../services/apps-ringbuilder.service";
import { useSelector } from "react-redux";
import catalogDiamondService from "../../services/catalog-diamond.service";
import searchDiamondService from "../../services/search-diamond.service";
import { useLocation } from "react-router-dom";
import { NotificationManager } from "react-notifications";
import DealerProfileService from "../../services/dealer-profile.service";

import space__icon from "../../assets/images/space__icon.png";
import {
  Button,
  Col,
  Divider,
  Empty,
  Input,
  Modal,
  Row,
  Select,
  Slider,
  Spin,
  Switch,
  Table,
  Tooltip,
} from "antd";

const { Option } = Select;
const ColorStoneSearch = (props) => {
  const { t } = useTranslation();
  const { Search } = Input;
  const initialCertInfoData = {
    name: "",
    email: "",
    phoneNumber: "",
    comments: "",
  };
  const initialCertInfoValidation = {
    nameVal: "",
    emailVal: "",
    phoneNumberVal: "",
    commentsVal: "",
  };
  const initialValidation = {
    depthMinVal: "",
    depthMaxVal: "",
    tableMinVal: "",
    tableMaxVal: "",
    CrownAngleMinVal: "",
    CrownAngleMaxVal: "",
    PavilionAngleMinVal: "",
    PavilionAngleMaxVal: "",
  };
  const [hideShowFilter, setHideShowFilter] = useState(true);
  const [showMoreFilter, setShowMoreFilter] = useState(false);
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(false);
  const [visible3, setVisible3] = useState(false);
  const [isEmail, setIsEmail] = useState(false);
  const [caratSlideValue, setCaratSlideValue] = useState([0, 20]);
  const [priceValue, setPriceValue] = useState([0, 1000000]);
  const [priceCaratValue, setPriceCaratValue] = useState([0, 22000]);
  const [pageNo, setPageNo] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [sortColumnName, setSortColumnName] = useState("tmpColumn Asc");
  const [sortType, setSortType] = useState("Asc");
  const [diamondList, setDiamondList] = useState([]);
  const [selectedRowDetails, setSelectedRowDetails] = useState({});
  const [selectedColumnId, setSelectedColumnId] = useState(0);
  const [fancyColorList, setFancyColorList] = useState([]);
  const [intensityList, setIntensityList] = useState([]);
  //const [overtoneList, setOverToneList] = useState([]);
  // For Apply Filter Button
  const [disableBtn, setDisableBtn] = useState(true);
  const [loading, setLoading] = useState(false);
  const [isVideo, setIsVideo] = useState(false);
  const [totalCount, setTotalCount] = useState(0);
  const [videoImageModal, setVideoImageModal] = useState(false);
  const [companyLogoLoading, setcompanyLogoLoading] = useState(false);
  const [selectedDealer, setSelectedDealer] = useState("");
  const [currentFilterData, setCurrentFilterData] = useState({});
  const [searchText, setSearchText] = useState("");
  const [isModalVisibleFullscreen, setIsModalVisibleFullscreen] =
    useState(false);
  const initialState = {
    DealerID: [],
    CertificateID: [],
    Shapes: [],
    CutFrom: null,
    CutTo: null,
    CaratMin: 0,
    CaratMax: 22,
    PriceMin: 0,
    PriceMax: 1000000,
    PriceCaratMin: 0,
    PriceCaratMax: 22000,
    ClarityFrom: "Any",
    ClarityTo: "Any",
    ColorFrom: null,
    ColorTo: null,
    DepthMin: 0,
    DepthMax: 100,
    TableMin: 0,
    TableMax: 100,
    PolishFrom: null,
    PolishTo: null,
    LengthMin: null,
    LengthMax: null,
    WidthMin: null,
    WidthMax: null,
    HeigthMin: null,
    HeigthMax: null,
    SummetryFrom: null,
    SummetryTo: null,
    GirdleFrom: null,
    GirdleTo: null,
    CrownAngleMin: 0,
    CrownAngleMax: 100,
    PavilionAngleMin: 0,
    PavilionAngleMax: 100,
    CuletFrom: null,
    CuletTo: null,
    CuletCondFrom: null,
    CuletCondTo: null,
    FluorescenceFrom: null,
    FluorescenceTo: null,
    MatchPairID: null,
    hasVideo: false,
    ShapeIsSelected: {
      Round: false,
      Radiant: false,
      Princess: false,
      Pear: false,
      Oval: false,
      Marquise: false,
      Heart: false,
      Emerald: false,
      Cushion: false,
      Asscher: false,
      All: false,
    },
    FancyColor: null,
    Overtone: null,
    Intensity: null,
  };
  const [state, setState] = useState(initialState);

  const [dealerList, setDealerList] = useState([]);
  const [certificateList, setCertificateList] = useState([]);
  const [cutList, setCutList] = useState([]);
  const [clarityList, setClarityList] = useState([]);
  const [emailCertificat, setEmailCertificat] = useState({});
  const [errorEmailCertificat, setErrorEmailCertificat] = useState({});
  const [bordered, setBordered] = useState(true);

  const [colorList] = useState([
    {
      colorID: null,
      colorName: t("Any"),
    },
    {
      colorID: 68,
      colorName: "D",
    },
    {
      colorID: 69,
      colorName: "E",
    },
    {
      colorID: 70,
      colorName: "F",
    },
    {
      colorID: 71,
      colorName: "G",
    },
    {
      colorID: 72,
      colorName: "H",
    },
    {
      colorID: 73,
      colorName: "I",
    },
    {
      colorID: 74,
      colorName: "J",
    },
    {
      colorID: 75,
      colorName: "K",
    },
    {
      colorID: 76,
      colorName: "L",
    },
    {
      colorID: 77,
      colorName: "M",
    },
    {
      colorID: 78,
      colorName: "N",
    },
    {
      colorID: 79,
      colorName: "O",
    },
    {
      colorID: 80,
      colorName: "P",
    },
    {
      colorID: 81,
      colorName: "Q",
    },
    {
      colorID: 82,
      colorName: "R",
    },
    {
      colorID: 83,
      colorName: "S",
    },
    {
      colorID: 84,
      colorName: "T",
    },
    {
      colorID: 85,
      colorName: "U",
    },
    {
      colorID: 86,
      colorName: "V",
    },
    {
      colorID: 87,
      colorName: "W",
    },
    {
      colorID: 88,
      colorName: "X",
    },
    {
      colorID: 89,
      colorName: "Y",
    },
    {
      colorID: 90,
      colorName: "Z",
    },
  ]);
  const [polishList, setPolishList] = useState([]);
  const [summetryList, setSummetryList] = useState([]);
  const [girdleList, setGirdleList] = useState([]);
  const [culetList, setCuletList] = useState([]);
  const [culetCondList, setCuletCondList] = useState([]);
  const [fluorescenceList] = useState([
    {
      fluorescenceID: 1,
      fluorescenceName: "None",
    },
    {
      fluorescenceID: 2,
      fluorescenceName: "Very Slight",
    },
    {
      fluorescenceID: 3,
      fluorescenceName: "Slight",
    },
    {
      fluorescenceID: 4,
      fluorescenceName: "Faint",
    },
    {
      fluorescenceID: 5,
      fluorescenceName: "Medium",
    },
    {
      fluorescenceID: 6,
      fluorescenceName: "Strong",
    },
    {
      fluorescenceID: 7,
      fluorescenceName: "Very Strong",
    },
  ]);
  const [matchedPairList] = useState([
    {
      matchedPairID: 1,
      matchedPairName: t("Search Single Stone"),
    },
    {
      matchedPairID: 2,
      matchedPairName: t("Search Match Pairs"),
    },
  ]);
  const [dealerId, setDealerId] = useState(0);
  const [preDealerId, setPreDealerId] = useState(0);
  const [msgData, setMsgData] = useState("");
  const [msgLoading, setMsgLoading] = useState(false);
  const [msgError, setMsgError] = useState("");

  const [EmailLoading, setEmailLoading] = useState(false);
  const [btnValue, setBtnValue] = useState(1);
  const [requestCertModalLoading, setRequestMoreCertModalLoading] =
    useState(false);

  const [validation, setValidation] = useState(initialValidation);

  const [requestCertModal, setRequestMoreCertModal] = useState(false);

  const [requestInfoDetails, setRequestInfoDetails] = useState({
    intDiamondId: "",
    dealerID: "",
  });

  const [certInfoValidation, setcertInfoDataValidation] = useState(
    initialCertInfoValidation
  );

  const [certInfoData, setcertInfoData] = useState(initialCertInfoData);

  const loginDetials = useSelector((state) => state.loginReducer.loginDetials);
  const currency = useSelector((state) => state.loginReducer.currency);

  const location = useLocation();

  const [currencySign, setCurrencySign] = useState("$");
  const [currencySymbol, setCurrencySymbol] = useState("USD");
  const [isResetFilter, setIsResetFilter] = useState(false);
  
  useEffect(() => {
    if (loginDetials?.responseData) {
      const dealerId = loginDetials.responseData.dealerId;
      setDealerId(dealerId);
      handleGetDynamicData(dealerId);
      
      // Only set the dealer ID from location state once
      const _dealerId = location?.state?.id;
      if (_dealerId && state.DealerID.length === 0) {
        console.log("GF:IF");
        console.log("GF:DealerID from location:", _dealerId);
        setPreDealerId(_dealerId);
        setState((prev) => ({
          ...prev,
          DealerID: [parseInt(_dealerId)], // 👈 must be array for multiple select
        }));
      } else if (!location?.state?.id && state.DealerID.length === 0) {
        console.log("GF:ELSE");
        setPreDealerId(0);
      }
    }
  }, [loginDetials, location?.state?.id]);


  const handleCertificateOpen = (item) => {
    if (item.certlink && item.certlink.trim() !== "") {
      window.open(
        item.certlink,
        "CERTVIEW",
        "scrollbars=yes,resizable=no,width=650,height=630"
      );
    } else {
      showCertInfoModal();
      setRequestInfoDetails({
        intDiamondId: item.intDiamondId,
        dealerID: item.dealerID,
      });
    }
  };

  const showCertInfoModal = () => {
    setRequestMoreCertModal(true);
  };
  const closeCertInfoModal = () => {
    setRequestMoreCertModal(false);
    setcertInfoData(initialCertInfoData);
    setcertInfoDataValidation(initialCertInfoValidation);
  };

  const handleCertInfoChange = (e, name, type) => {
    setcertInfoData({
      ...certInfoData,
      [name]: e.target.value,
    });
    if (name == "name") {
      setcertInfoDataValidation((prevdata) => ({
        ...prevdata,
        nameVal: "",
      }));
    }
    if (name == "email") {
      setcertInfoDataValidation((prevdata) => ({
        ...prevdata,
        emailVal: "",
      }));
    }
    if (name == "phoneNumber") {
      setcertInfoDataValidation((prevdata) => ({
        ...prevdata,
        phoneNumberVal: "",
      }));
    }
  };

  const handleSubmitRequestCert = () => {
    handleSaveRequestCertificate();
    setcertInfoData(initialCertInfoData);
  };

  const handleRequestCertificateValidation = () => {
    const { name, email, phoneNumber } = certInfoData;
    const certInfoValidation = {
      nameVal: "",
      emailVal: "",
      phoneNumberVal: "",
    };
    let isValid = true;

    if (!name) {
      isValid = false;
      certInfoValidation.nameVal = t("First Name is Compulsory");
    }

    let validRegex =
      /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    if (!email) {
      isValid = false;
      certInfoValidation.emailVal = t("Email address is compulsory");
    } else if (!email.match(validRegex)) {
      isValid = false;
      certInfoValidation.emailVal = t("Email address is invalid");
    } else {
      certInfoValidation.emailVal = "";
    }

    if (!phoneNumber) {
      isValid = false;
      certInfoValidation.phoneNumberVal = t(t("Phone number is compulsory"));
    } else if (
      (phoneNumber.length >= 10 && phoneNumber.includes("-")) ||
      (phoneNumber.length >= 10 && phoneNumber.includes(",")) ||
      (phoneNumber.length >= 10 && phoneNumber.includes("+"))
    ) {
      certInfoValidation.phoneNumberVal = "";
    } else if (!/^(?!0{10,15})(\+\d{1,3}[-]?)?\d{10,15}$/.test(phoneNumber)) {
      isValid = false;
      certInfoValidation.phoneNumberVal = t("Phone number is invalid");
    } else {
      certInfoValidation.phoneNumberVal = "";
    }
    if (!isValid) {
      setcertInfoDataValidation(certInfoValidation);
    }

    return isValid;
  };

  const handleSaveRequestCertificate = async () => {
    const isValid = handleRequestCertificateValidation();
    if (!isValid) {
      return false;
    }
    try {
      let inputData = {
        dealerID: dealerId.toString(),
        did: requestInfoDetails.intDiamondId,
        name: certInfoData.name,
        email: certInfoData.email,
        phone: certInfoData.phoneNumber,
        comments: certInfoData.comments,
        retailerID: requestInfoDetails.dealerID,
      };

      setRequestMoreCertModalLoading(true);
      await AppsRingBuilderService.RingBuilderRequestCertificate(inputData)
        .then((response) => {
          let message = response.data.message;

          if (message === "Success") {
            NotificationManager.success(
              t(
                "Your request has been sent to GemFind. A representative will be contacting you shortly."
              )
            );
            setcertInfoData(initialCertInfoData);
            setcertInfoDataValidation(initialCertInfoValidation);
            setRequestMoreCertModalLoading(false);
          } else {
            NotificationManager.success(
              t(
                "Your request has been sent to GemFind. A representative will be contacting you shortly."
              )
            );
            setcertInfoData(initialCertInfoData);
            setcertInfoDataValidation(initialCertInfoValidation);
            setRequestMoreCertModalLoading(false);
          }
        })
        .catch((error) => {
          console.log(error);
          setcertInfoData(initialCertInfoData);
          setcertInfoDataValidation(initialCertInfoValidation);
          setRequestMoreCertModalLoading(false);
        });
    } catch (error) {
      console.log(error);
      setcertInfoData(initialCertInfoData);
      setcertInfoDataValidation(initialCertInfoValidation);
      setRequestMoreCertModalLoading(false);
    }
  };

  const handleSendFriendemail = () => {
    try {
      let inputData = {
        name: emailCertificat.Name,
        email: emailCertificat.Email,
        friendsName: emailCertificat.FriendsName,
        friendsEmail: emailCertificat.FriendsEmail,
        comments: emailCertificat.Comments,
        dealerID: parseInt(dealerId),
        dInventoryID: parseInt(selectedRowDetails.intDiamondId),
      };
      setEmailLoading(true);
      catalogDiamondService
        .SendFriendemail(inputData)
        .then((response) => {
          let message = response.data.message;

          if (message === "Success") {
            setEmailLoading(false);
            setVisible3(false);
            NotificationManager.success(t("Mail sent successfully."));
          } else {
            setEmailLoading(false);
            NotificationManager.error(t("Mail not sent."));
          }
        })
        .catch((error) => {
          setEmailLoading(false);
          console.log(error);
        });
    } catch (error) {
      setEmailLoading(false);
      console.log(error);
    }
    emailCertificat.Name = "";
    emailCertificat.Email = "";
    emailCertificat.FriendsName = "";
    emailCertificat.FriendsEmail = "";
    emailCertificat.Comments = "";
    setEmailCertificat((prevState) => ({
      ...prevState,
      ...emailCertificat,
    }));
  };

  const handleSendMsg = () => {
    try {
      let inputData = {
        dealrId: selectedRowDetails.dealerID,
        msg: msgData,
        intDiamondId: selectedRowDetails.intDiamondId.toString(),
      };
      setMsgLoading(true);
      catalogDiamondService
        .SendMsg(inputData)
        .then((response) => {
          let message = response.data.message;
          setMsgLoading(false);

          if (message === "Success") {
            setVisible1(false);
            setMsgData("");
            setMsgError("");
            NotificationManager.success(t("Message sent successfully."));
          } else {
            NotificationManager.error(t("Message not sent."));
          }
        })
        .catch((error) => {
          setMsgLoading(false);
          console.log(error);
        });
    } catch (error) {
      setMsgLoading(false);
      console.log(error);
    }
  };
  const handleMsgValidation = () => {
    if (msgData) {
      if (msgData.trim() === "") {
        setMsgError(t("Please enter message."));
      } else {
        handleSendMsg();
      }
    } else {
      setMsgError(t("Please enter message."));
    }
  };
  const handleCancel1 = () => {
    setVisible1(false);
    setMsgData("");
    setMsgError("");
  };
  const handleOk1 = (item) => {
    setSelectedRowDetails(item);
    handleGetCompanyProfileDetails(item.dealerID);
    setMsgData("");
    setMsgError("");
    setVisible1(true);
  };

  const handleGetDealersForDiamondCatalogList = async (id, Data) => {
    try {
      let inputData = {
        type: props.type || "Mined",
        dealerId: id,
      };
      await catalogDiamondService
        .GetDealersForDiamondSearch(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          handleGetCertificatesForDiamondCatalogList(id);
          handleGetDiamondList(
            id,
            pageNo,
            pageSize,
            sortColumnName,
            sortType,
            "",
            Data
          );
          if (message === "Success") {
            setDealerList(responseData);
          } else {
            setDealerList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetCertificatesForDiamondCatalogList = async (id) => {
    try {
      let inputData = {
        type: props.type || "Mined",
      };
      await catalogDiamondService
        .GetCertificatesForDiamondCatalogList(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;

          handleGetAllMINEDropDownList();

          if (message === "Success") {
            setCertificateList(responseData);
          } else {
            setCertificateList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  const handleGetAllMINEDropDownList = async () => {
    try {
      let inputData = {
        type: "",
      };
      await catalogDiamondService
        .GetAllMINEDropDownList(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          handleGetAllDropdownData();
          if (message === "Success") {
            setCutList(responseData[0]);
            setClarityList(responseData[1]);
            setPolishList(responseData[2]);
            setSummetryList(responseData[3]);
            setGirdleList(responseData[4]);
            setCuletList(responseData[5]);
            setCuletCondList(responseData[6]);
          } else {
            setCutList([]);
            setClarityList([]);
            setPolishList([]);
            setSummetryList([]);
            setGirdleList([]);
            setCuletList([]);
            setCuletCondList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };

  const handleOk = (item) => {
    setSelectedRowDetails(item);
    handleGetCompanyProfileDetails(item.dealerID);
    setMsgData("");
    setMsgError("");
    setVisible1(true);
  };

  const handleGetCompanyProfileDetails = (id) => {
    let inputData = {
      dealerID: id,
    };
    setcompanyLogoLoading(true);
    try {
      DealerProfileService.GetCompanyProfileDetails(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (responseData) {
              setcompanyLogoLoading(false);
              setSelectedDealer(responseData.dealerCompany);
            }
          } else {
            setcompanyLogoLoading(false);
            setSelectedDealer("");
          }
        })
        .catch((error) => {
          setcompanyLogoLoading(false);
          console.log(error);
        });
    } catch (error) {
      setcompanyLogoLoading(false);
      console.log(error);
    }
  };

  const handleCancel = () => {
    setVisible(false);
    setSelectedDealer("");
    setMsgData("");
    setMsgError("");
  };

  const onChangeMultiDrop = (e, name) => {
    let tempState = state;
    let updatedValue = e;
    
    // Handle "Search all" logic for CertificateID
    if (name === "CertificateID") {
      if (updatedValue.includes("0") && updatedValue.length > 1) {   
        const wasSearchAllPreviouslySelected = state[name] && state[name].includes("0");
        if (!wasSearchAllPreviouslySelected) { 
          updatedValue = ["0"];
        } else {
          updatedValue = updatedValue.filter(value => value !== "0");
        }
      }
    } else if(name == "DealerID") {
      if (updatedValue.includes(parseInt(preDealerId)) && updatedValue.length > 1) {   
        console.log('available');
      } else {
        console.log('not available');
            setPreDealerId(0);
      }
    }
    
    tempState[name] = updatedValue;

    console.log('GF:1')
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));

    if (
      validation.tableMaxVal === "" &&
      validation.tableMinVal === "" &&
      validation.depthMaxVal === "" &&
      validation.depthMinVal === "" &&
      validation.CrownAngleMinVal === "" &&
      validation.CrownAngleMaxVal === "" &&
      validation.PavilionAngleMinVal === "" &&
      validation.PavilionAngleMaxVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }
  };

  const onChangeDrop = (e, name) => {
    console.log('GF:2 - onChangeDrop:', name, '=', e);
    setState((prevState) => ({
      ...prevState,
      [name]: e,
    }));

    if (
      validation.tableMaxVal === "" &&
      validation.tableMinVal === "" &&
      validation.depthMaxVal === "" &&
      validation.depthMinVal === "" &&
      validation.CrownAngleMinVal === "" &&
      validation.CrownAngleMaxVal === "" &&
      validation.PavilionAngleMinVal === "" &&
      validation.PavilionAngleMaxVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }
  };

  const onChange = (e, name) => {
    let tempState = state;
    tempState[name] = e.target.value;
    setValidation(validation);
    if (
      validation.tableMaxVal === "" &&
      validation.tableMinVal === "" &&
      validation.depthMaxVal === "" &&
      validation.depthMinVal === "" &&
      validation.CrownAngleMinVal === "" &&
      validation.CrownAngleMaxVal === "" &&
      validation.PavilionAngleMinVal === "" &&
      validation.PavilionAngleMaxVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }

    const value = e.target.value;
    const key = e.nativeEvent.data;

    // Block invalid characters (if user tries to type e, E, +, -)
    if (["e", "E", "+", "-"].includes(key)) {
      return; // don't update state
    }
    // List of fields that need 0–100 constraint
    const rangedFields = [
      "DepthMin",
      "DepthMax",
      "TableMin",
      "TableMax",
      "CrownAngleMin",
      "CrownAngleMax",
      "PavilionAngleMin",
      "PavilionAngleMax",
    ];

    if (rangedFields.includes(name)) {
      if (value === "" || (Number(value) >= 0 && Number(value) <= 100)) {
    console.log('GF:3')
        setState((prevState) => ({
          ...prevState,
          [name]: value,
        }));
      }
    } else {
    console.log('GF:4')
      setState((prevState) => ({
        ...prevState,
        [name]: value,
      }));
    }
  };

  const onSwitchChange = (e, name) => {
    let tempState = state;
    tempState[name] = e;

    console.log('GF:5')
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));

    if (
      validation.tableMaxVal === "" &&
      validation.tableMinVal === "" &&
      validation.depthMaxVal === "" &&
      validation.depthMinVal === "" &&
      validation.CrownAngleMinVal === "" &&
      validation.CrownAngleMaxVal === "" &&
      validation.PavilionAngleMinVal === "" &&
      validation.PavilionAngleMaxVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }
  };

  const onResetFilter = () => {
    let tempState = state;
    tempState.DealerID = [];
    tempState.CertificateID = [];
    tempState.CutFrom = null;
    tempState.CutTo = null;
    tempState.ClarityFrom = "Any";
    tempState.ClarityTo = "Any";
    tempState.ColorFrom = null;
    tempState.ColorTo = null;
    tempState.DepthMin = 0;
    tempState.DepthMax = 100;
    tempState.TableMin = 0;
    tempState.TableMax = 100;
    tempState.PolishFrom = null;
    tempState.PolishTo = null;
    tempState.LengthMin = null;
    tempState.LengthMax = null;
    tempState.WidthMin = null;
    tempState.WidthMax = null;
    tempState.HeigthMin = null;
    tempState.HeigthMax = null;
    tempState.SummetryFrom = null;
    tempState.SummetryTo = null;
    tempState.GirdleFrom = null;
    tempState.GirdleTo = null;
    tempState.CrownAngleMin = 0;
    tempState.CrownAngleMax = 100;
    tempState.PavilionAngleMin = 0;
    tempState.PavilionAngleMax = 100;
    tempState.CuletFrom = null;
    tempState.CuletTo = null;
    tempState.CuletCondFrom = null;
    tempState.CuletCondTo = null;
    tempState.FluorescenceFrom = null;
    tempState.FluorescenceTo = null;
    tempState.FancyColor = null;
    tempState.Intensity = null;
    tempState.Overtone = null;
    tempState.MatchPairID = null;
    tempState.hasVideo = false;
    state.ShapeIsSelected.All = false;
    state.ShapeIsSelected.Circle = false;
    state.ShapeIsSelected.Emerald = false;
    state.ShapeIsSelected.Heart = false;
    state.ShapeIsSelected.Oval = false;
    state.ShapeIsSelected.Radiant = false;
    state.ShapeIsSelected.Round = false;
    state.ShapeIsSelected.Marquise = false;
    state.ShapeIsSelected.Princess = false;
    state.ShapeIsSelected.Pear = false;
    state.ShapeIsSelected.Cushion = false;
    state.ShapeIsSelected.Asscher = false;
    setCaratSlideValue([state.CaratMin, state.CaratMax]);
    setPriceValue([state.PriceMin.toString(), state.PriceMax.toString()]);
    setPriceCaratValue([state.PriceCaratMin, state.PriceCaratMax]);
    setValidation(initialValidation);
    setDisableBtn(false);
    setIsResetFilter(true);
    setSearchText("");
    console.log('GF:6');
    setPreDealerId(0);
    
    setState((prevState) => ({
      ...prevState,
      ...tempState,
    }));
  };

  useEffect(() => {
    if (isResetFilter) {
      handleGetDiamondList(
        dealerId,
        pageNo,
        pageSize,
        sortColumnName,
        sortType,
        "",
        state
      );
    }
  }, [isResetFilter]);

  const onShapeClick = (shape) => {
    if (
      validation.tableMaxVal === "" &&
      validation.tableMinVal === "" &&
      validation.depthMaxVal === "" &&
      validation.depthMinVal === "" &&
      validation.CrownAngleMinVal === "" &&
      validation.CrownAngleMaxVal === "" &&
      validation.PavilionAngleMinVal === "" &&
      validation.PavilionAngleMaxVal === ""
    ) {
      setDisableBtn(false);
      setBtnValue(1);
    } else {
      setDisableBtn(true);
      setBtnValue(0);
    }
    if (shape === "All") {
      state.ShapeIsSelected.All = !state.ShapeIsSelected.All;
      state.ShapeIsSelected.Round = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Radiant = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Princess = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Pear = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Oval = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Marquise = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Heart = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Emerald = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Cushion = state.ShapeIsSelected.All;
      state.ShapeIsSelected.Asscher = state.ShapeIsSelected.All;
    } else {
      state.ShapeIsSelected.All = false;
      state.ShapeIsSelected[shape] = !state.ShapeIsSelected[shape];
    }

    console.log('GF:7')
    setState((prevState) => ({
      ...prevState,
      ...state,
    }));
  };

  const handleHideShowFilter = () => {
    setHideShowFilter(!hideShowFilter);
  };

  // Helper function to get clarityID from claritydetails
  // Using index+1 because API clarityIDs are wrong (all 0)
  const getClarityId = (clarityName) => {
    if (!clarityName || clarityName === "Any") return "-1";
    const index = clarityList.findIndex(item => item.claritydetails === clarityName);
    return index >= 0 ? (index + 1).toString() : "-1";
  };

  const handleGetDiamondList = async (
    id,
    pageNo,
    pageSize,
    sortColumnName,
    sortType,
    searchVal,
    responseData
  ) => {
    setPageNo(pageNo);
    setPageSize(pageSize);

    // Store responseData for reuse in pagination
    if (responseData && Object.keys(responseData).length > 0) {
      setCurrentFilterData(responseData);
    }

    // Use stored filter data if responseData is empty
    const filterData = (responseData && Object.keys(responseData).length > 0)
      ? responseData
      : currentFilterData;
    let tempshapes = Object.keys(state.ShapeIsSelected)
      .filter((k) => state.ShapeIsSelected[k] === true)
      .map((x) => x)
      .join(",");

    const caratMin = String(
      filterData.sldCaratMin ?? (isResetFilter ? state.CaratMin : caratSlideValue[0])
    );

    const caratMax = String(
      filterData.sldCaratMax ?? (isResetFilter ? state.CaratMax : caratSlideValue[1])
    );

    let inputData = {
      dealerID: id.toString(),
      shapes: tempshapes,
      colorMin: state.ColorFrom == null ? "-1" : state.ColorFrom.toString(),
      colorMax: state.ColorTo == null ? "-1" : state.ColorTo.toString(),

      clarityMin: getClarityId(state.ClarityFrom),
      clarityMax: getClarityId(state.ClarityTo),

      caratMin: caratMin,

      caratMax: caratMax,

      priceMin: filterData.sldPriceMin
        ? filterData.sldPriceMin.toString()
        : isResetFilter
          ? "0" //state.PriceMin.toString()
          : priceValue[0].toString(),
      priceMax: filterData.sldPriceMax
        ? "0"
        : priceValue[1] == 1000000 || priceValue[1] == "1000000"
          ? "1000000"
          : priceValue[1].toString(),

      certificate:
        state.CertificateID.length > 0
          ? state.CertificateID.map((x) => x).join(",")
          : "%",
      cutGradeMin: state.CutFrom == null ? "-1" : state.CutFrom.toString(),
      cutGradeMax: state.CutTo == null ? "-1" : state.CutTo.toString(),
      symmetryMin:
        state.SummetryFrom == null ? "-1" : state.SummetryFrom.toString(),
      symmetryMax:
        state.SummetryTo == null ? "-1" : state.SummetryTo.toString(),
      polishMin: state.PolishFrom == null ? "-1" : state.PolishFrom.toString(),
      polishMax: state.PolishTo == null ? "-1" : state.PolishTo.toString(),
      depthMin: filterData.sldDepthMin
        ? filterData.sldDepthMin.toString()
        : state.DepthMin
          ? state.DepthMin.toString()
          : "",
      depthMax: filterData.sldDepthMax
        ? filterData.sldDepthMax.toString()
        : state.DepthMax
          ? state.DepthMax.toString()
          : "",
      tableMin: filterData.sldTableMin
        ? filterData.sldTableMin.toString()
        : state.TableMin
          ? state.TableMin.toString()
          : "",
      tableMax: filterData.sldTableMax
        ? filterData.sldTableMax.toString()
        : state.TableMax
          ? state.TableMax.toString()
          : "",
      fluorescenceMin:
        state.FluorescenceFrom == null
          ? "-1"
          : state.FluorescenceFrom.toString(),
      fluorescenceMax:
        state.FluorescenceTo == null ? "-1" : state.FluorescenceTo.toString(),
      pairCode: "",
      orderBy:
        sortColumnName == "txtStockNo"
          ? "DealerInventoryNo"
          : sortColumnName == "txtShape"
            ? "Cut"
            : sortColumnName == "realPrice"
              ? "FltPrice"
              : sortColumnName == "fltRapPercent"
                ? "OffRapaport"
                : sortColumnName == "fltCarat"
                  ? "Size"
                  : sortColumnName == "txtCulet" || sortColumnName == "txtCutGrade"
                    ? "CutGrade"
                    : sortColumnName == "txtColor"
                      ? "Color"
                      : sortColumnName == "txtClarity"
                        ? "Clarity"
                        : sortColumnName == "fltRapPercent"
                          ? "OffRapaport"
                          : sortColumnName == "fltPrice"
                            ? "FltPrice"
                            : sortColumnName == "fltDepth"
                              ? "Depth"
                              : sortColumnName == "fltTable"
                                ? "TableMeasure"
                                : sortColumnName == "txtCertificate"
                                  ? "Certificate"
                                  : sortColumnName == "txtSymmetry"
                                    ? "Symmetry"
                                    : sortColumnName == "dealer"
                                      ? "DealerID"
                                      : sortColumnName == "txtFluorescence"
                                        ? "Flouresence"
                                        : sortColumnName == "txtMeasurements"
                                          ? "Measurements"
                                          : sortColumnName == "txtPolish"
                                            ? "Polish"
                                            : "tmpColumn Asc",
      orderType: sortType ? sortType : "Asc",
      pageNumber: pageNo + "",
      pageSize: pageSize + "",
      invenID: "",
      strDetailLinkURL: "dealerlink",
      caratPriceMin: isResetFilter
        ? state.PriceCaratMin.toString()
        : priceCaratValue[0]
          ? priceCaratValue[0].toString()
          : "0",

      caratPriceMax: isResetFilter
        ? "0"
        : priceCaratValue[1] === 22000
          ? "0"
          : priceCaratValue[1].toString(),
      polishList:
        state.PolishFrom == null && state.PolishTo == null ? "-1" : "",
      symmetryList:
        state.SummetryFrom == null && state.SummetryTo == null ? "-1" : "",
      fluorescenceList:
        state.FluorescenceFrom == null && state.FluorescenceTo == null
          ? "-1"
          : "",
      cutGradeList: state.CutFrom == null && state.CutTo == null ? "-1" : "",
      colorList: state.ColorFrom == null && state.ColorTo == null ? "-1" : "",
      clarityList:
        getClarityId(state.ClarityFrom) === "-1" && getClarityId(state.ClarityTo) === "-1" ? "-1" : "",
      sOrigin: "",
      intOptimize: 0,
      intCulet1: state.CuletFrom ? state.CuletFrom : 0,
      intCulet2: state.CuletTo ? state.CuletTo : 20,
      intCuletCondition1: state.CuletCondFrom ? state.CuletCondFrom : 0,
      intCuletCondition2: state.CuletCondTo ? state.CuletCondTo : 20,
      fltCrownAngle1: state.CrownAngleMin
        ? parseInt(state.CrownAngleMin, 10)
        : 0,
      fltCrownAngle2: state.CrownAngleMax
        ? parseInt(state.CrownAngleMax, 10)
        : 100,
      fltPavilionAngle1: state.PavilionAngleMin
        ? parseInt(state.PavilionAngleMin, 10)
        : 0,
      fltPavilionAngle2: state.PavilionAngleMax
        ? parseInt(state.PavilionAngleMax, 10)
        : 100,
      intGirdle1: state.GirdleFrom ? state.GirdleFrom : -1,
      intGirdle2: state.GirdleTo ? state.GirdleTo : -1,
      intCutGrade: 0,
      uploadDateMin: "",
      uploadDateMax: "",
      strSelectedDealers:
        location?.state?.id
          ? location.state.id.toString()
          : state.DealerID.length > 0
            ? state.DealerID.map((x) => x).join(",")
            : "", //here
      selectedDealerConunt:
        state.DealerID.length > 0 ? state.DealerID.length : 1,
      fancyColor: state.FancyColor ? state.FancyColor.toString() : "",
      intIntensity: state.Intensity ? state.Intensity : 0,
      intOvertone: state.Overtone ? state.Overtone : 1,
      overtone: "",
      overtone2: "",
      strMatchedPairs: state.MatchPairID ? state.MatchPairID.toString() : "0",
      fltWidth1: state.WidthMin ? state.WidthMin.toString() : "-1",
      fltWidth2: state.WidthMax ? state.WidthMax.toString() : "-1",
      fltHeight1: state.HeigthMin ? state.HeigthMin.toString() : "-1",
      fltHeight2: state.HeigthMax ? state.HeigthMax.toString() : "-1",
      fltLength1: state.LengthMin ? state.LengthMin.toString() : "-1",
      fltLength2: state.LengthMax ? state.LengthMax.toString() : "-1",
      strSelectedInvID: "",
      flagDD: "1",
      checkInventory: "Catalog",
      video: state.hasVideo === true ? "1" : "0",
      isComm: 0,
      did: searchVal ? searchVal : "",
    };

    setLoading(true);
    try {
      await searchDiamondService
        .SearchMinedDiamonds(inputData, props.type)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            if (message === "Success") {
              if (responseData) {
                setDiamondList(responseData);
                setTotalCount(Number(responseData[0].intTotalRecords));
                if (isResetFilter) {
                  setIsResetFilter(false);
                }
                setLoading(false);
              }
            } else {
              setDiamondList([]);
              setTotalCount(0);
              setLoading(false);
            }
          } else {
            setDiamondList([]);
            setTotalCount(0);
            setLoading(false);
          }
        })
        .catch((error) => {
          setLoading(false);
          console.log(error);
        });
    } catch (error) {
      setLoading(false);
      console.log(error);
    }
  };

  const handleGetDynamicData = async (id) => {
    try {
      let inputData = {
        dealerId: id.toString(),
      };
      setLoading(true);
      await catalogDiamondService
        .GetDynamicData(inputData)
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;
          if (message === "Success") {
            responseData.sldPrinceCaratMin = "0";
            responseData.sldPriceCaratMax = "22000";
            const tempState = { ...state };
            tempState.CaratMax = parseFloat(responseData.sldCaratMax || 0);
            tempState.CaratMin = parseFloat(responseData.sldCaratMin || 0);
            tempState.PriceMax = parseFloat(responseData.sldPriceMax || 0);
            tempState.PriceMin = parseFloat(responseData.sldPriceMin || 0);
            tempState.DepthMax = parseFloat(responseData.sldDepthMax || 0);
            tempState.DepthMin = parseFloat(responseData.sldDepthMin || 0);
            tempState.TableMax = parseFloat(responseData.sldTableMax || 0);
            tempState.TableMin = parseFloat(responseData.sldTableMin || 0);
            tempState.PriceCaratMin = parseFloat(
              responseData.sldPrinceCaratMin || 0
            );
            tempState.PriceCaratMax = parseFloat(
              responseData.sldPriceCaratMax || 0
            );
            setCaratSlideValue([tempState.CaratMin, tempState.CaratMax]);
            setPriceValue([
              tempState.PriceMin.toString(),
              tempState.PriceMax.toString(),
            ]);
            setCurrencySign(responseData?.currencySign || "$");
            setCurrencySymbol(responseData?.currencySymbol || "USD");
            setPriceCaratValue([
              tempState.PriceCaratMin,
              tempState.PriceCaratMax,
            ]);
            console.log('GF:8')

            setState((prevState) => ({
              ...prevState,
              ...tempState,
            }));
          } else {
          }
          handleGetDealersForDiamondCatalogList(id, responseData);
        })
        .catch((error) => {
          handleGetDealersForDiamondCatalogList(id, state);
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  
  const handleGetAllDropdownData = async () => {
    try {
      await catalogDiamondService
        .GetAllDropdownData()
        .then((response) => {
          let message = response.data.message;
          let responseData = response.data.responseData;

          //handleGetOverToneForDiamondCatalogList();
          if (message === "Success") {
            if (responseData) {
              let Color = responseData.tblStoneColor;
              let diamondintensity = responseData.diamondIntensity;
              setFancyColorList(Color);
              setIntensityList(diamondintensity);
            } else {
              setFancyColorList([]);
              setIntensityList([]);
            }
          } else {
            setFancyColorList([]);
          }
        })
        .catch((error) => {
          console.log(error);
        });
    } catch (error) {
      console.log(error);
    }
  };
  /*Diamond search custom binding ends*/

  const handleOpenVideoImageModal = (row, isVideo) => {
    setIsVideo(isVideo);
    setSelectedRowDetails(row);
    setVideoImageModal(true);
  };
  const handleCloseVideoImageModal = () => {
    setVideoImageModal(false);
  };
  const handleOpenDetailsModal = (row) => {
    setSelectedRowDetails(row);
    setVisible(true);
  };
  const handleOpenIsEmail = () => {
    setIsEmail(true);
  };
  const handleCloseIsEmail = () => {
    setIsEmail(false);
    emailCertificat.Name = "";
    emailCertificat.Email = "";
    emailCertificat.FriendsName = "";
    emailCertificat.FriendsEmail = "";
    emailCertificat.Comments = "";
    setEmailCertificat((prevState) => ({
      ...prevState,
      ...emailCertificat,
    }));
  };
  const handleEmailCertificatChange = (e) => {
    const { name, value } = e.target;
    emailCertificat[name] = value;
    errorEmailCertificat[name] = null;
    setEmailCertificat((prevState) => ({
      ...prevState,
      ...emailCertificat,
    }));
    setErrorEmailCertificat((prevState) => ({
      ...prevState,
      ...errorEmailCertificat,
    }));
  };
  const handleValidEmailCertificat = () => {
    const regex =
      /^(([^<>()[\]\.,;:\s@\"]+(\.[^<>()[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i;

    let isValid = true;
    let tempEmailCertificat = emailCertificat;
    let tempErrorEmailCertificat = errorEmailCertificat;
    if (!tempEmailCertificat["Name"]) {
      tempErrorEmailCertificat["Name"] = t("Enter Name.");
      isValid = false;
    } else {
      tempErrorEmailCertificat["Name"] = null;
    }

    if (!tempEmailCertificat["Email"]) {
      tempErrorEmailCertificat["Email"] = t("Enter Email Address.");
      isValid = false;
    } else if (!tempEmailCertificat["Email"].trim()) {
      tempErrorEmailCertificat["Email"] = t("Enter Email Address.");
      isValid = false;
    } else if (regex.test(tempEmailCertificat["Email"]) === false) {
      tempErrorEmailCertificat["Email"] = t("Email is not valid.");
      isValid = false;
    }

    if (!tempEmailCertificat["FriendsName"]) {
      tempErrorEmailCertificat["FriendsName"] = t("Enter Friend's Name.");
      isValid = false;
    } else {
      tempErrorEmailCertificat["FriendsName"] = null;
    }

    if (!tempEmailCertificat["FriendsEmail"]) {
      tempErrorEmailCertificat["FriendsEmail"] = t(
        "Enter Friend's Email Address."
      );
      isValid = false;
    } else if (!tempEmailCertificat["FriendsEmail"].trim()) {
      tempErrorEmailCertificat["FriendsEmail"] = t(
        "Enter Friend's Email Address."
      );
      isValid = false;
    } else if (regex.test(tempEmailCertificat["Email"]) === false) {
      tempErrorEmailCertificat["FriendsEmail"] = t("Email is not valid.");
      isValid = false;
    }

    setErrorEmailCertificat((prevState) => ({
      ...prevState,
      ...tempErrorEmailCertificat,
    }));
    return isValid;
  };

  const getCutDisplay = (cutGrade) => {
    if (!cutGrade) return { full: '', abbreviated: '' };

    const normalized = cutGrade.toString().trim().toLowerCase();

    // Map both full forms and abbreviations
    const cutMap = {
      'fair': { abbr: 'F', full: 'Fair' },
      'f': { abbr: 'F', full: 'Fair' },
      'ideal': { abbr: 'I', full: 'Ideal' },
      'i': { abbr: 'I', full: 'Ideal' },
      'very good': { abbr: 'VG', full: 'Very Good' },
      'vg': { abbr: 'VG', full: 'Very Good' },
      'excellent': { abbr: 'EX', full: 'Excellent' },
      'ex': { abbr: 'EX', full: 'Excellent' },
      'good': { abbr: 'G', full: 'Good' },
      'g': { abbr: 'G', full: 'Good' }
    };

    const match = cutMap[normalized] || { abbr: cutGrade, full: cutGrade };

    return {
      full: match.full,
      abbreviated: match.abbr
    };
  };


  const handleCertificateEmailSend = () => {
    if (handleValidEmailCertificat()) {
      handleSendFriendemail();
    }
  };

  const handleApplyFilter = () => {
    setHideShowFilter(true);
    handleGetDiamondList(
      dealerId,
      1,
      15,
      "tmpColumn Asc",
      "Asc",
      searchText,
      state
    );

    setDisableBtn(true);
  };

  const handleTableASCDES = (pagination, filters, sorter) => {
    var contentArea = document.getElementsByClassName("content__area")[0]; if (contentArea) contentArea.scrollTop = 0;
    setTimeout(function() {
      document.querySelectorAll('div').forEach(function(el) { if (el.scrollTop > 0) el.scrollTop = 0; });
      window.scrollTo(0, 0);
    }, 100);
    let type = "";
    let column = "";
    if (sorter.order == "descend") {
      type = "DESC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else if (sorter.order == "ascend") {
      type = "ASC";
      column = sorter.field;
      setSortType(type);
      setSortColumnName(column);
    } else {
      type = "ASC";
      column = "tmpColumn Asc";
      setSortColumnName(column);
      setSortType(type);
    }

    handleGetDiamondList(
      dealerId,
      pagination.current,
      pagination.pageSize,
      column,
      type,
      searchText,
      "",
      false,
      state
    );
  };
  const firstsetPriceSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...priceValue];
    var StrValue = e.target.value && e.target.value.replace(currencySign, "");
    var Value = StrValue.replace(/,/g, "");

    if (Value.replace(/,/g, "") > state.PriceMax) {
      e.preventDefault();
    } else if (num == 0 || num == "0") {
      if (Value == "") {
        newArr[0] = 0;
        setPriceValue(newArr);
      } else {
        if (newArr[0] == 0) {
          newArr[0] = Value;
          setPriceValue(newArr);
        } else {
          newArr[0] = Value;
          setPriceValue(newArr);
        }
      }
    } else if (Number(num) == 1) {
      if (Value == "") {
        newArr[1] = 0;
        setPriceValue(newArr);
      } else {
        if (newArr[1] == 0 && Value.includes(".")) {
          newArr[1] = Value;
          setPriceValue(newArr);
        } else {
          if (newArr[1] == 0) {
            newArr[1] = parseFloat(Value);
            setPriceValue(newArr);
          } else {
            newArr[1] = Value;
            setPriceValue(newArr);
          }
        }
      }
    }
  };
  const firstsetPriceCaratSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...priceCaratValue];
    var StrValue = e.target.value && e.target.value.replace(currencySign, "");

    var Value = StrValue.replace(/,/g, "");
    if (Number(parseFloat(Value.replace(/,/g, ""))) > state.PriceCaratMax) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (Value == "") {
        newArr[0] = 0;
        setPriceCaratValue(newArr);
      } else {
        if (newArr[0] == 0) {
          newArr[0] = Value;
          setPriceCaratValue(newArr);
        } else {
          newArr[0] = Value;
          setPriceCaratValue(newArr);
        }
      }
    } else if (Number(num) == 1) {
      if (Value == "") {
        newArr[1] = 0;
        setPriceCaratValue(newArr);
      } else {
        if (newArr[1] == 0 && Value.includes(".")) {
          newArr[1] = Value;
          setPriceCaratValue(newArr);
        } else {
          if (newArr[1] == 0) {
            newArr[1] = parseFloat(Value);
            setPriceCaratValue(newArr);
          } else {
            newArr[1] = Value;
            setPriceCaratValue(newArr);
          }
        }
      }
    }
  };
  const firstsetCaratSlideValue = (e, num) => {
    setDisableBtn(false);
    let newArr = [...caratSlideValue];
    var StrValue = e.target.value && e.target.value.replace("$", "");
    var Value = StrValue.replace(/,/g, "");
    if (Number(parseFloat(e.target.value.replace(/,/g, ""))) > state.CaratMax) {
      e.preventDefault();
    } else if (Number(num) == 0) {
      if (e.target.value == "" || e.target.value == ".") {
        newArr[0] = 0;
        setCaratSlideValue(newArr);
      } else {
        if (newArr[0] == 0 && Value.includes(".")) {
          var dottedamount = Value.split(".");
          var amount =
            Number(dottedamount[0]).toLocaleString("en-US") +
            "." +
            dottedamount[1];
          newArr[0] = amount;
          setCaratSlideValue(newArr);
        } else {
          if (newArr[0] == 0) {
            newArr[0] = parseFloat(Value);
            setCaratSlideValue(newArr);
          } else {
            newArr[0] = Value;
            setCaratSlideValue(newArr);
          }
        }
      }
    } else if (Number(num) == 1) {
      if (e.target.value == "" || e.target.value == ".") {
        newArr[1] = 0;
        setCaratSlideValue(newArr);
      } else {
        if (newArr[1] == 0 && Value.includes(".")) {
          var dottedamount = Value.split(".");
          var amount =
            Number(dottedamount[0]).toLocaleString("en-US") +
            "." +
            dottedamount[1];
          newArr[1] = amount;
          setCaratSlideValue(newArr);
        } else {
          if (newArr[1] == 0) {
            newArr[1] = parseFloat(Value);
            setCaratSlideValue(newArr);
          } else {
            newArr[1] = Value;
            setCaratSlideValue(newArr);
          }
        }
      }
    }
  };

  const onKeyPressEvent1 = (event) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);
    if (!new RegExp("[0-9.]").test(keyValue)) event.preventDefault();
    return;
  };
  function formatMoney(amount) {
    try {
      if (amount && amount.toString().includes(".")) {
        var dottedamount = amount.split(".");
        var amount =
          Number(dottedamount[0]).toLocaleString("en-US") +
          "." +
          dottedamount[1];
      } else {
        var amount = Number(amount).toLocaleString("en-US");
      }
      return amount;
    } catch (e) {
      console.log(e);
    }
  }

  const showModalFullscreen = (row) => {
    setSelectedRowDetails(row);
    setIsModalVisibleFullscreen(true);
  };
  const handleCancelFullscreen = () => {
    setIsModalVisibleFullscreen(false);
  };

  return (
    <React.Fragment>
      <div className="vdiamond_section">
        <div className="form__fields">
          <div className="col-md-12">
            <div className="row">
              <div className="col-md-12">
                <Row className="mb-3 table-info-header">
                  <Col>
                    <h4 className="workarea__heading ">
                      {props.type === "LAB"
                        ? t("Lab Diamond Search")
                        : t("Color Stone Search")}
                    </h4>
                  </Col>
                  <div className="d-flex-sm-block_search">
                    <Col
                      sm={24}
                      md={16}
                      mb-mobile
                      flex-align-center
                      className="mr-desktop"
                    >
                      <div className="search__bar  mb-mobile ">
                        <Search
                          placeholder={t("Stock #")}
                          allowClear
                          value={searchText ? searchText : ""}
                          onChange={(e) => setSearchText(e.target.value)}
                          onSearch={(value) => {
                            const trimmedValue = value.trim();
                            setSearchText(value);
                            setPageNo(1);
                            handleGetDiamondList(
                              dealerId,
                              1,
                              pageSize,
                              sortColumnName,
                              sortType,
                              trimmedValue,
                              state
                            );
                          }}
                        />
                      </div>
                    </Col>
                    <Col className="flex-none">
                      <button
                        className="primary-btn"
                        onClick={handleHideShowFilter}
                      >
                        <img src={Filter_icon} alt="" width="14px" />
                        {hideShowFilter ? (
                          <span>
                            {t("Filter")} <i className="fa fa-angle-down"></i>
                          </span>
                        ) : (
                          <span>
                            {t("Filter")} <i className="fa fa-angle-up"></i>
                          </span>
                        )}
                      </button>
                    </Col>
                  </div>
                </Row>
              </div>
              <div className="col-md-12 relative">
                <div className="filter_section">
                  <div
                    className={
                      hideShowFilter
                        ? "form__fields filter_inpsection hide"
                        : "form__fields filter_inpsection"
                    }
                  >
                    <div className="col-md-12">
                      <div className="row">
                        <div className="col-lg-12 col-md-12">
                          <div className="input__block">
                            <label> {t("Shapes")} </label>
                            <div className="imgselct__div">
                              <div
                                className={
                                  state.ShapeIsSelected.Round
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Round")}
                              >
                                <img src={Roundimg} alt="" />
                                <span> {t("Round")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Radiant
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Radiant")}
                              >
                                <img src={RadiantImg} alt="" />
                                <span> {t("Radiant")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Princess
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Princess")}
                              >
                                <img src={PrincessImg} alt="" />
                                <span> {t("Princess")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Pear ? "selected" : null
                                }
                                onClick={() => onShapeClick("Pear")}
                              >
                                <img src={PearImg} alt="" />
                                <span> {t("Pear")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Oval ? "selected" : null
                                }
                                onClick={() => onShapeClick("Oval")}
                              >
                                <img src={OvalImg} alt="" />
                                <span> {t("Oval")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Marquise
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Marquise")}
                              >
                                <img src={MarquiseImg} alt="" />
                                <span> {t("Marquise")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Heart
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Heart")}
                              >
                                <img src={HeartImg} alt="" />
                                <span> {t("Heart")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Emerald
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Emerald")}
                              >
                                <img src={EmeraldImg} alt="" />
                                <span> {t("Emerald")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Cushion
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Cushion")}
                              >
                                <img src={CushionImg} alt="" />
                                <span> {t("Cushion")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.Asscher
                                    ? "selected"
                                    : null
                                }
                                onClick={() => onShapeClick("Asscher")}
                              >
                                <img src={AsscherImg} alt="" />
                                <span> {t("Asscher")} </span>
                              </div>
                              <div
                                className={
                                  state.ShapeIsSelected.All
                                    ? "selected all__div"
                                    : "all__div"
                                }
                                onClick={() => onShapeClick("All")}
                              >
                                <span> {t("All")} </span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-4 col-md-6">
                          <div className="sliderrange__maindiv">
                            <label> {t("Price")} </label>
                            <div className="col-md-12 mt-3">
                              <Slider
                                range
                                value={priceValue}
                                min={state.PriceMin}
                                max={state.PriceMax}
                                onChange={(e) => {
                                  setPriceValue(e);

                                  {
                                    btnValue == 1
                                      ? setDisableBtn(false)
                                      : setDisableBtn(true);
                                  }
                                }}
                              />
                              <div className="rangeSlider__values">
                                <div className="input__block">
                                  <input
                                    type="text"
                                    // value={
                                    //   currencySign +
                                    //   formatMoney(priceValue[0])
                                    // }
                                    value={
                                      currencySign +
                                      priceValue[0]
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    }
                                    onChange={(e) => {
                                      firstsetPriceSlideValue(e, 0);
                                      // handleSliderCaratValue(e);
                                      // setCaratSlideValue(e);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>
                                <div className="input__block">
                                  <input
                                    type="text"
                                    // value={
                                    //   currencySign +
                                    //   formatMoney(priceValue[1])
                                    // }
                                    value={
                                      currencySign +
                                      priceValue[1]
                                        .toString()
                                        .replace(/\B(?=(\d{3})+(?!\d))/g, ",")
                                    }
                                    onChange={(e) => {
                                      firstsetPriceSlideValue(e, 1);
                                      // handleSliderCaratValue(e);
                                      // setCaratSlideValue(e);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="sliderrange__maindiv">
                            <label>
                              {t("Cost")} / {t("Carat")}{" "}
                            </label>
                            <div className="col-md-12 mt-3">
                              <Slider
                                range
                                value={priceCaratValue}
                                min={state.PriceCaratMin}
                                max={state.PriceCaratMax}
                                onChange={(e) => {
                                  setPriceCaratValue(e);

                                  {
                                    btnValue == 1
                                      ? setDisableBtn(false)
                                      : setDisableBtn(true);
                                  }
                                }}
                              />
                              <div className="rangeSlider__values">
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={
                                      currencySign +
                                      formatMoney(priceCaratValue[0])
                                    }
                                    onChange={(e) => {
                                      firstsetPriceCaratSlideValue(e, 0);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                                <div>
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={
                                      currencySign +
                                      formatMoney(priceCaratValue[1])
                                    }
                                    onChange={(e) => {
                                      firstsetPriceCaratSlideValue(e, 1);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-4 col-md-6">
                          <div className="sliderrange__maindiv">
                            <label> {t("Carat")} </label>
                            <div className="col-md-12 mt-3">
                              <Slider
                                range
                                value={caratSlideValue}
                                min={state.CaratMin}
                                max={state.CaratMax}
                                step={0.01}
                                onChange={(e) => {
                                  setCaratSlideValue(e);
                                  {
                                    btnValue == 1
                                      ? setDisableBtn(false)
                                      : setDisableBtn(true);
                                  }
                                }}
                              />
                              <div className="rangeSlider__values">
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={caratSlideValue[0].toLocaleString(
                                      "en-US"
                                    )}
                                    onChange={(e) => {
                                      firstsetCaratSlideValue(e, 0);
                                      // handleSliderCaratValue(e);
                                      // setCaratSlideValue(e);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                  {/* <span className="dollar__symbol">$</span> */}
                                </div>
                                <div>
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>
                                <div className="input__block">
                                  <input
                                    type="text"
                                    value={caratSlideValue[1].toLocaleString(
                                      "en-US"
                                    )}
                                    // value={formatMoney(caratSlideValue[1])}
                                    onChange={(e) => {
                                      firstsetCaratSlideValue(e, 1);
                                      // handleSliderCaratValue(e);
                                      // setCaratSlideValue(e);
                                    }}
                                    onKeyPress={onKeyPressEvent1}
                                  />
                                  {/* <span className="dollar__symbol">$</span> */}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                        {console.log('GF:state: ' + state.DealerID)}
                        {console.log('GF:preDealerId: ' + preDealerId)}
                        
                        <div className="col-lg-3 col-md-6">
                          <div className="input__block">
                            <label> {t("Dealers")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              mode="multiple"
                              showArrow
                              placeholder={t("Select Dealer")}
                              optionFilterProp="children"
                              onChange={(e) => onChangeMultiDrop(e, "DealerID")}
                              value={
                                state.DealerID?.length
                                  ? state.DealerID
                                  : preDealerId
                                  ? [parseInt(preDealerId)]
                                  : []
                              }
                            >
                              <Option value="0">{t("Search all")}</Option>
                              {dealerList?.map((item, i) => {
                                return (
                                  <Option value={item.dealerID}>
                                    {item.dealerCompany}
                                  </Option>
                                );
                              })}
                            </Select>
                          </div>
                        </div>
                        <div className="col-lg-1 col-md-6">
                          <div className="input__block">
                            <label> {t("Certificates")} </label>
                            <Select
                              className="border__grey"
                              showSearch
                              mode="multiple"
                              showArrow
                              placeholder={t("Select")}
                              optionFilterProp="children"
                              onChange={(e) =>
                                onChangeMultiDrop(e, "CertificateID")
                              }
                              value={state.CertificateID}
                            >
                              {/* <Option value="0">{t("Search all")}</Option> */}
                              {certificateList.map((item, i) => {
                                return (
                                  <Option value={item.certificateValue}>
                                    {t(item.certificateValue)}
                                  </Option>
                                );
                              })}
                              {/* {certificatesForDiamondCatalogList.map(
                                    (item) => {
                                      return (
                                        <React.Fragment>
                                          <Option
                                            value={item.certificateValue}
                                            key={item.certificateValue}
                                          >
                                            {item.certificateValue}
                                          </Option>
                                        </React.Fragment>
                                      );
                                    }
                                  )} */}
                              {/* <Option value="GIA">GIA</Option>
                              <Option value="AGS">AGS</Option>
                              <Option value="GCAL">GCAL</Option>
                              <Option value="IGI">IGI</Option>
                              <Option value="EGLUSA">EGL USA</Option>
                              <Option value="FM">FM</Option>
                              <Option value="HRD">HRD</Option>
                              <Option value="EGLINT">EGL INT</Option>
                              <Option value="OTHER">Other</Option> */}


                            </Select>
                          </div>
                        </div>

                        <div className="col-lg-2 col-md-6">
                          <div className="row">
                            <div className="input__block">
                              <label className="lbl__txt">{t("Cut")}</label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "CutFrom")}
                                  value={state.CutFrom}
                                >
                                  <Option>{t("Any")}</Option>
                                  {cutList.map((item) => (
                                    <Option
                                      key={item.cutGradeId}
                                      value={item.cutGradeId}
                                    >
                                      {t(item.cutGradeValue)}
                                    </Option>
                                  ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "CutTo")}
                                  value={state.CutTo}
                                >
                                  <Option>{t("Any")}</Option>
                                  {cutList.map((item) => (
                                    <Option
                                      key={item.cutGradeId}
                                      value={item.cutGradeId}
                                    >
                                      {t(item.cutGradeValue)}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="row">
                            <div className="input__block">
                              <label className="lbl__txt">{t("Clarity")}</label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  placeholder={t("Any")}
                                  allowClear
                                  onChange={(e) =>
                                    onChangeDrop(e, "ClarityFrom")
                                  }
                                  value={state.ClarityFrom || "Any"}
                                >
                                  <Option key="clarity-from-any" value="Any">
                                    {t("Any")}
                                  </Option>
                                  {clarityList.map((item, index) => (
                                    <Option
                                      key={`clarity-from-${index}`}
                                      value={item.claritydetails}
                                    >
                                      {t(item.claritydetails)}
                                    </Option>
                                  ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  placeholder={t("Any")}
                                  allowClear
                                  onChange={(e) => onChangeDrop(e, "ClarityTo")}
                                  value={state.ClarityTo || "Any"}
                                >
                                  <Option key="clarity-to-any" value="Any">
                                    {t("Any")}
                                  </Option>
                                  {clarityList.map((item, index) => (
                                    <Option
                                      key={`clarity-to-${index}`}
                                      value={item.claritydetails}
                                    >
                                      {t(item.claritydetails)}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Color")}</label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                optionFilterProp="children"
                                onChange={(e) => onChangeDrop(e, "ColorFrom")}
                                value={state.ColorFrom}
                              >
                                {colorList.map((item) => (
                                  <Option
                                    key={item.colorID}
                                    value={item.colorID}
                                  >
                                    {item.colorName}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                optionFilterProp="children"
                                onChange={(e) => onChangeDrop(e, "ColorTo")}
                                value={state.ColorTo}
                              >
                                {colorList.map((item) => (
                                  <Option
                                    key={item.colorID}
                                    value={item.colorID}
                                  >
                                    {item.colorName}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Depth")}</label>
                            <div className="filter-range-pair percentage_filter">
                              <div className="input__block col-lg-5">
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  value={state.DepthMin}
                                  onChange={(e) => {
                                    if (
                                      e.target.value?.length <= 3 &&
                                      Number(e.target.value) >= 0 &&
                                      Number(e.target.value) <= 100
                                    ) {
                                      onChange(e, "DepthMin");
                                    }
                                  }}
                                  className={
                                    validation.depthMinVal && "border__red"
                                  }
                                />
                                <span className="ampcent__txt">%</span>
                                {validation.depthMinVal && (
                                  <span className="error-color-red">
                                    {validation.depthMinVal}
                                  </span>
                                )}
                              </div>

                              <div className="separator ">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>
                              <div className="input__block col-lg-5">
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  value={state.DepthMax}
                                  onChange={(e) => {
                                    if (
                                      e.target.value?.length <= 3 &&
                                      Number(e.target.value) >= 0 &&
                                      Number(e.target.value) <= 100
                                    ) {
                                      onChange(e, "DepthMax");
                                    }
                                  }}
                                  className={
                                    validation.depthMaxVal && "border__red"
                                  }
                                />
                                <span className="ampcent__txt">%</span>
                                {validation.depthMaxVal && (
                                  <span className="error-color-red">
                                    {validation.depthMaxVal}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Table")}</label>
                            <div className="filter-range-pair percentage_filter">
                              <div className="input__block col-lg-5">
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  value={state.TableMin}
                                  onChange={(e) => {
                                    if (
                                      e.target.value?.length <= 3 &&
                                      Number(e.target.value) >= 0 &&
                                      Number(e.target.value) <= 100
                                    ) {
                                      onChange(e, "TableMin");
                                    }
                                  }}
                                  className={
                                    validation.tableMinVal && "border__red"
                                  }
                                />
                                <span className="ampcent__txt">%</span>
                                {validation.tableMinVal && (
                                  <span className="error-color-red">
                                    {validation.tableMinVal}
                                  </span>
                                )}
                              </div>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <div className="input__block col-lg-5">
                                <input
                                  type="number"
                                  min={0}
                                  max={100}
                                  value={state.TableMax}
                                  onChange={(e) => {
                                    if (
                                      e.target.value?.length <= 3 &&
                                      Number(e.target.value) >= 0 &&
                                      Number(e.target.value) <= 100
                                    ) {
                                      onChange(e, "TableMax");
                                    }
                                  }}
                                  className={
                                    validation.tableMaxVal && "border__red"
                                  }
                                />
                                <span className="ampcent__txt">%</span>
                                {validation.tableMaxVal && (
                                  <span className="error-color-red">
                                    {validation.tableMaxVal}
                                  </span>
                                )}
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">{t("Polish")}</label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                optionFilterProp="children"
                                onChange={(e) => onChangeDrop(e, "PolishFrom")}
                                value={state.PolishFrom}
                              >
                                <Option>{t("Any")}</Option>
                                {polishList.map((item) => (
                                  <Option
                                    key={item.polishID}
                                    value={item.polishID}
                                  >
                                    {t(item.polishValue)}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                optionFilterProp="children"
                                onChange={(e) => onChangeDrop(e, "PolishTo")}
                                value={state.PolishTo}
                              >
                                <Option>{t("Any")}</Option>
                                {polishList.map((item) => (
                                  <Option
                                    key={item.polishID}
                                    value={item.polishID}
                                  >
                                    {t(item.polishValue)}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-2 col-md-6">
                          <div className="input__block">
                            <label className="lbl__txt">
                              {t("Fluorescence")}
                            </label>
                            <div className="filter-range-pair">
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  onChangeDrop(e, "FluorescenceFrom")
                                }
                                value={state.FluorescenceFrom}
                              >
                                <Option>{t("Any")}</Option>
                                {fluorescenceList.map((item) => (
                                  <Option
                                    key={item.fluorescenceID}
                                    value={item.fluorescenceID}
                                  >
                                    {t(item.fluorescenceName)}
                                  </Option>
                                ))}
                              </Select>

                              <div className="separator">
                                <img
                                  src={space__icon}
                                  className="img-fluid space__icon"
                                />
                              </div>

                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Any")}
                                optionFilterProp="children"
                                onChange={(e) =>
                                  onChangeDrop(e, "FluorescenceTo")
                                }
                                value={state.FluorescenceTo}
                              >
                                <Option>{t("Any")}</Option>
                                {fluorescenceList.map((item) => (
                                  <Option
                                    key={item.fluorescenceID}
                                    value={item.fluorescenceID}
                                  >
                                    {t(item.fluorescenceName)}
                                  </Option>
                                ))}
                              </Select>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    {showMoreFilter && (
                      <div className="col-md-12 mt-2">
                        <div className="row">
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Length(mm)")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "LengthMin")}
                                  value={state.LengthMin}
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "LengthMax")}
                                  value={state.LengthMax}
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Width(mm)")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "WidthMin")}
                                  value={state.WidthMin}
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "WidthMax")}
                                  value={state.WidthMax}
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Height(mm)")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "HeigthMin")}
                                  value={state.HeigthMin}
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "HeigthMax")}
                                  value={state.HeigthMax}
                                >
                                  <Option>{t("Any")}</Option>
                                  {Array(15)
                                    .fill(1)
                                    .map((_, i) => (
                                      <Option key={i + 1} value={i + 1}>
                                        {i + 1}
                                      </Option>
                                    ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Symmetry")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    onChangeDrop(e, "SummetryFrom")
                                  }
                                  value={state.SummetryFrom}
                                >
                                  <Option>{t("Any")}</Option>
                                  {summetryList.map((item) => (
                                    <Option
                                      key={item.symmetryID}
                                      value={item.symmetryID}
                                    >
                                      {t(item.symmetryValue)}
                                    </Option>
                                  ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    onChangeDrop(e, "SummetryTo")
                                  }
                                  value={state.SummetryTo}
                                >
                                  <Option>{t("Any")}</Option>
                                  {summetryList.map((item) => (
                                    <Option
                                      key={item.symmetryID}
                                      value={item.symmetryID}
                                    >
                                      {t(item.symmetryValue)}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">{t("Girdle")}</label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    onChangeDrop(e, "GirdleFrom")
                                  }
                                  value={state.GirdleFrom}
                                >
                                  <Option>{t("Any")}</Option>
                                  {girdleList.map((item) => (
                                    <Option
                                      key={item.diamondGirdleID}
                                      value={item.diamondGirdleID}
                                    >
                                      {t(item.girdleValue)}
                                    </Option>
                                  ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "GirdleTo")}
                                  value={state.GirdleTo}
                                >
                                  <Option>{t("Any")}</Option>
                                  {girdleList.map((item) => (
                                    <Option
                                      key={item.diamondGirdleID}
                                      value={item.diamondGirdleID}
                                    >
                                      {t(item.girdleValue)}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Pavilion Angle")}
                              </label>
                              <div className="filter-range-pair percentage_filter">
                                <div className="input__block col-lg-5">
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={state.PavilionAngleMin}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        onChange(e, "PavilionAngleMin");
                                      }
                                    }}
                                    className={
                                      validation.PavilionAngleMinVal &&
                                      "border__red"
                                    }
                                  />
                                  <span className="ampcent__txt">%</span>
                                  {validation.PavilionAngleMinVal && (
                                    <span className="error-color-red">
                                      {validation.PavilionAngleMinVal}
                                    </span>
                                  )}
                                </div>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <div className="input__block col-lg-5">
                                  <input
                                    type="number"
                                    min={0}
                                    max={100}
                                    value={state.PavilionAngleMax}
                                    onChange={(e) => {
                                      if (
                                        e.target.value?.length <= 3 &&
                                        Number(e.target.value) >= 0 &&
                                        Number(e.target.value) <= 100
                                      ) {
                                        onChange(e, "PavilionAngleMax");
                                      }
                                    }}
                                    className={
                                      validation.PavilionAngleMaxVal &&
                                      "border__red"
                                    }
                                  />
                                  <span className="ampcent__txt">%</span>
                                  {validation.PavilionAngleMaxVal && (
                                    <span className="error-color-red">
                                      {validation.PavilionAngleMaxVal}
                                    </span>
                                  )}
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">{t("Culet")}</label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "CuletFrom")}
                                  value={state.CuletFrom}
                                >
                                  <Option>{t("Any")}</Option>
                                  {culetList?.map((item) => (
                                    <Option
                                      key={item.diamondCuletID}
                                      value={item.diamondCuletID}
                                    >
                                      {t(item.culetValue)}
                                    </Option>
                                  ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) => onChangeDrop(e, "CuletTo")}
                                  value={state.CuletTo}
                                >
                                  <Option>{t("Any")}</Option>
                                  {culetList?.map((item) => (
                                    <Option
                                      key={item.diamondCuletID}
                                      value={item.diamondCuletID}
                                    >
                                      {t(item.culetValue)}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>
                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label className="lbl__txt">
                                {t("Culet Condition")}
                              </label>
                              <div className="filter-range-pair">
                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    onChangeDrop(e, "CuletCondFrom")
                                  }
                                  value={state.CuletCondFrom}
                                >
                                  <Option>{t("Any")}</Option>
                                  {culetCondList.map((item) => (
                                    <Option
                                      key={item.diamondCuletConditionID}
                                      value={item.diamondCuletConditionID}
                                    >
                                      {t(item.culetConditionValue)}
                                    </Option>
                                  ))}
                                </Select>

                                <div className="separator">
                                  <img
                                    src={space__icon}
                                    className="img-fluid space__icon"
                                  />
                                </div>

                                <Select
                                  className="border__grey"
                                  showSearch
                                  placeholder={t("Any")}
                                  optionFilterProp="children"
                                  onChange={(e) =>
                                    onChangeDrop(e, "CuletCondTo")
                                  }
                                  value={state.CuletCondTo}
                                >
                                  <Option>{t("Any")}</Option>
                                  {culetCondList.map((item) => (
                                    <Option
                                      key={item.diamondCuletConditionID}
                                      value={item.diamondCuletConditionID}
                                    >
                                      {t(item.culetConditionValue)}
                                    </Option>
                                  ))}
                                </Select>
                              </div>
                            </div>
                          </div>

                          <div className="col-lg-2 col-md-6">
                            <div className="input__block">
                              <label> {t("Matched Pairs")} </label>
                              <Select
                                className="border__grey"
                                showSearch
                                placeholder={t("Search All Stones")}
                                optionFilterProp="children"
                                onChange={(e) => onChangeDrop(e, "MatchPairID")}
                                value={state.MatchPairID}
                              >
                                {matchedPairList.map((item, i) => {
                                  return (
                                    <Option value={item.matchedPairID}>
                                      {item.matchedPairName}
                                    </Option>
                                  );
                                })}
                              </Select>
                            </div>
                          </div>
                          <div className="col-lg-3 col-md-6">
                            <div className="input__block">
                              <label> {t("Has Video")} </label>
                              <Switch
                                name="hasVideo"
                                checkedChildren={t("Yes")}
                                unCheckedChildren={t("No")}
                                checked={state.hasVideo}
                                onChange={(e) => onSwitchChange(e, "hasVideo")}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                    <div className="row">
                      <div className="col-md-12 filtbtn_div">
                        <button
                          className="primary-btn mr-2"
                          onClick={() => setShowMoreFilter(!showMoreFilter)}
                        >
                          {showMoreFilter == false
                            ? t("More Filters")
                            : t("Less Filters")}
                        </button>

                        <button
                          className="primary-btn mr-2"
                          onClick={onResetFilter}
                        >
                          {" "}
                          {t("Reset Filters")}
                        </button>
                        <button
                          className={
                            disableBtn ? "disabled-btn" : "primary-btn"
                          }
                          disabled={disableBtn}
                          onClick={() => handleApplyFilter()}
                          loading={loading}
                        >
                          {" "}
                          {t("Apply Filters")}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className="col-lg-12">
                <Table
                  className="vdiamond__table mobile_tbl"
                  columns={[
                    // {
                    //   title: "",
                    //   dataIndex: "view",
                    //   width: "30px",
                    //   render: (item, row) => {
                    //     return (
                    //       <React.Fragment>
                    //         <div
                    //           className="infoicon__div"
                    //           onClick={() => handleOpenDetailsModal(row)}
                    //         >
                    //           <i className="fa fa-info-circle"></i>
                    //         </div>
                    //       </React.Fragment>
                    //     );
                    //   },
                    // },
                    {
                      title: (
                        <Tooltip title={t("Stock #")}>{t("Stock #")}</Tooltip>
                      ),
                      onCell: () => ({
                        onClick: (e) => {
                          e.preventDefault();
                          e.stopPropagation();
                        },
                      }),
                      responsive: ["lg"],
                      dataIndex: "txtStockNo",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                    },
                    {
                      title: <Tooltip title={t("Shape")}>{t("Shape")}</Tooltip>,
                      dataIndex: "txtShape",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                      render: (item, row) => {
                        const imageSource =
                          props.type === "LAB"
                            ? row.imageFileName
                            : row.imageSmallShape;
                        return (
                          <div className="shape__img">
                            <div className="shape__icon">
                              <img src={imageSource} />
                            </div>
                            {window.innerWidth > 768 && (
                              <span>{row.txtShape}</span>
                            )}
                          </div>
                        );
                      },
                    },
                    {
                      title: <Tooltip title={t("Size")}>{t("Size")}</Tooltip>,

                      dataIndex: "fltCarat",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                    },
                    {
                      title: (
                        <Tooltip title={t("Cut")}>
                          <span>{t("Cut")}</span>
                        </Tooltip>
                      ),
                      dataIndex: props.type === "LAB" ? "txtCutGrade" : "txtCulet",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                      width: 70,
                      render: (text) => {
                        const display = getCutDisplay(text);

                        return (
                          <>
                            <span className="d-none d-md-inline">{t(display.full)}</span>
                            <span className="d-md-none">{display.abbreviated}</span>
                          </>
                        );
                      }
                    }
                    ,

                    {
                      title: <Tooltip title={t("Color")}>{t("Color")}</Tooltip>,

                      dataIndex: "txtColor",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                    },
                    {
                      title: (
                        <Tooltip title={t("Clarity")}>{t("Clarity")}</Tooltip>
                      ),

                      dataIndex: "txtClarity",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                    },
                    {
                      title: <Tooltip title={t("Off %")}>{t("Off %")}</Tooltip>,

                      responsive: ["lg"],
                      dataIndex: "fltRapPercent",
                      showSorterTooltip: false,
                      sorter: (a, b) =>
                        parseFloat(a.fltRapPercent) -
                        parseFloat(b.fltRapPercent),
                    },
                    {
                      title: <Tooltip title={t("Cost")}>{t("Cost")}</Tooltip>,

                      dataIndex: "realPrice",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                      ellipsis: true,
                      render: (item, row) => {
                        return (
                          <>
                            {currencySign ? currencySign + " " : " "}
                            {row.realPrice
                              ? parseFloat(row.realPrice).toFixed(2).replace(
                                /\B(?=(\d{3})+(?!\d))/g,
                                ","
                              )
                              : ""}
                          </>
                        );
                      },
                    },
                    {
                      title: <Tooltip title={t("Depth")}>{t("Depth")}</Tooltip>,

                      responsive: ["lg"],
                      dataIndex: "fltDepth",
                      ellipsis: true,
                      showSorterTooltip: false,

                      sorter: (a, b) => { },
                      render: (item, row) => {
                        return row.fltDepth + "%";
                      },
                    },
                    {
                      title: <Tooltip title={t("Table")}>{t("Table")}</Tooltip>,
                      sorter: (a, b) => { },
                      ellipsis: true,
                      showSorterTooltip: false,
                      responsive: ["lg"],
                      dataIndex: "fltTable",
                      render: (item, row) => {
                        return row.fltTable + "%";
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Certificate")}>{t("Cert.")}</Tooltip>
                      ),

                      dataIndex: "txtCertificate",
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      ellipsis: true,
                      sorter: (a, b) => { },
                      render: (row, item) => {
                        return (
                          <div className="infoicon__div">
                            <span
                              className="linkText"
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSelectedColumnId(item?.dealerInventoryNo);
                                handleCertificateOpen(item);
                              }}
                            >
                              {item.txtCertificate}
                            </span>
                          </div>
                        );
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Fluorescence")}>
                          {t("Fluor.")}
                        </Tooltip>
                      ),
                      ellipsis: true,
                      dataIndex: "txtFluorescence",
                      sorter: (a, b) => { },
                      responsive: ["lg"],
                      showSorterTooltip: false,
                      render: (item, row) => {
                        //console.log(dealerMemberTypeName)
                        return row.txtFluorescence;
                      },
                    },
                    {
                      title: (
                        <Tooltip title={t("Polish")}>{t("Polish")}</Tooltip>
                      ),

                      responsive: ["lg"],
                      dataIndex: "txtPolish",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                    },
                    {
                      title: (
                        <Tooltip title={t("Symmetry")}>{t("Sym.")}</Tooltip>
                      ),

                      responsive: ["lg"],
                      dataIndex: "txtSymmetry",
                      showSorterTooltip: false,
                      sorter: (a, b) => { },
                    },
                    {
                      title: (
                        <Tooltip title={t("Dealer")}>{t("Dealer")}</Tooltip>
                      ),

                      ellipsis: true,
                      responsive: ["lg"],
                      dataIndex: "dealerCompany",
                      showSorterTooltip: false,
                      width: 150,
                      sorter: false,
                      render: (item, row) => {
                        return (
                          <div
                            style={{
                              display: "flex",
                              justifyContent: "start",
                              width: "100%",
                            }}
                            className="infoicon__div"
                          >
                            <span
                              onClick={(e) => {
                                e.preventDefault();
                                e.stopPropagation();
                                setSelectedColumnId(row?.dealerInventoryNo);
                                handleOk1(row);
                              }}
                              style={{
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                                display: "inline-block",
                                width: "100%",
                                cursor: "pointer",
                              }}
                              title={row.dealerCompany}
                            >
                              <i
                                className="fa fa-comments"
                                aria-hidden="true"
                              ></i>{" "}
                              {row.dealerCompany}
                            </span>
                          </div>
                        );
                      },
                    },
                    {
                      title: <Tooltip title={t("Video")}>{t("Video")}</Tooltip>,
                      width: "40px",
                      ellipsis: true,
                      responsive: ["lg"],

                      onCell: (row) => {
                        if (row.videoFileName) {
                          return {
                            onClick: (e) => {
                              e.stopPropagation();
                            },
                          };
                        }
                        return {};
                      },

                      render: (item, row) => {
                        return row.videoFileName ? (
                          <div
                            style={{ padding: "5px", margin: "-4px" }}
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setSelectedColumnId(row?.dealerInventoryNo);
                              handleOpenVideoImageModal(row, true);
                            }}
                          >
                            <i
                              className="fa fa-video-camera"
                              style={{ color: "#0078d7", cursor: "pointer" }}
                            ></i>
                          </div>
                        ) : null;
                      },
                    },
                  ]}
                  loading={{ spinning: loading, size: "large" }}
                  dataSource={diamondList}
                  pagination={{
                    size: "small",
                    total: totalCount,
                    pageSize: pageSize,
                    pageSizeOptions: [10, 15, 20, 50, 100],
                    responsive: true,
                    showSizeChanger: true,
                    current: pageNo,
                    showTotal: (total, range) => (
                      <div className="pagination-total">{`${range[0]}-${range[1]} of ${total} diamonds`}</div>
                    ),
                  }}
                  onRow={(record, recordIndex) => ({
                    onClick: (event) => {
                      setSelectedColumnId(record?.dealerInventoryNo);
                      handleOpenDetailsModal(record);
                    },
                  })}
                  rowClassName={(record) =>
                    record.dealerInventoryNo == selectedColumnId
                      ? "row-active"
                      : ""
                  }
                  onChange={(pagination, filters, sorters) => {
                    handleTableASCDES(pagination, filters, sorters);
                  }}
                  rowKey={(record) => record.intDiamondId}
                />
              </div>
              <div className="col-lg-12">
                <Modal
                  title={t("View Details")}
                  className="modalvdiamond__section"
                  centered
                  visible={visible}
                  onOk={handleCancel}
                  onCancel={handleCancel}
                  width={1200}
                  footer={[
                    <Button key="back" onClick={handleCancel}>
                      {t("Cancel")}
                    </Button>,
                    <Button
                      key="submit"
                      type="primary"
                      onClick={() => handleOk(selectedRowDetails)}
                    >
                      {t("Contact Dealer")}
                    </Button>,
                  ]}
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          <div className="row">
                            <div className="col-lg-2 text-center">
                              <div className="viewdtls__left">
                                <img
                                  src={selectedRowDetails.imageBigShape}
                                  alt=""
                                />
                              </div>
                              <div>
                                {selectedRowDetails.videoFileName && (
                                  <i
                                    onClick={(e) => {
                                      e.preventDefault();
                                      e.stopPropagation();
                                      setSelectedColumnId(
                                        selectedRowDetails?.dealerInventoryNo
                                      );
                                      handleOpenVideoImageModal(
                                        selectedRowDetails,
                                        true
                                      );
                                    }}
                                    className="fa fa-video-camera"
                                    style={{
                                      color: "#0078d7",
                                      cursor: "pointer",
                                    }}
                                  ></i>
                                )}
                                {selectedRowDetails?.imageBigShape ? (
                                  <i
                                    class="fa fa-arrows-alt mt-6 linkText ml-2"
                                    aria-hidden="true"
                                    onClick={() => {
                                      showModalFullscreen(selectedRowDetails);
                                    }}
                                  ></i>
                                ) : null}
                              </div>
                            </div>
                            <div className="col-lg-10">
                              <div
                                className="info__div"
                                style={{ display: "flex", gap: "20px" }}
                              >
                                <div style={{ flex: 1 }}>
                                  <p>
                                    <span className="head__txt">
                                      {t("GemFind")}#:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.intDiamondId}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {" "}
                                      {t("Cost Price")}{t(" (" + currencySymbol + ")")}
                                      :
                                    </span>{" "}
                                    <span className="val__txt">
                                      {currencySign +
                                        " " +
                                        (selectedRowDetails.realPrice
                                          ? parseFloat(
                                            selectedRowDetails.realPrice
                                          ).toFixed(2).replace(
                                            /\B(?=(\d{3})+(?!\d))/g,
                                            ","
                                          )
                                          : "")}
                                    </span>
                                  </p>

                                  {(!currencySign || currencySymbol !== "USD") && (
                                    <p>
                                      <span className="head__txt">
                                        {t("Cost Price")}{t(" (USD)")}:
                                      </span>{" "}
                                      <span className="val__txt">
                                        {"$" +
                                          " " +
                                          (selectedRowDetails.fltPriceUsd
                                            ? parseFloat(
                                              selectedRowDetails.fltPriceUsd
                                            ).toFixed(2)
                                            : "")}
                                      </span>
                                    </p>
                                  )}

                                  <p>
                                    <span className="head__txt">
                                      {t("Color")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtColor}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Depth")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltDepth + "%"}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Carat Weight")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltCarat}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Symmetry")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtSymmetry}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Fluorescence")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtFluorescence}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Measurements")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtMeasurements}
                                    </span>
                                  </p>
                                </div>

                                <div
                                  style={{
                                    flex: 1,
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "20px",
                                  }}
                                >
                                  <p>
                                    <span className="head__txt">
                                      {t("Treatment")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.treatment}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Shape")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtShape}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Clarity")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtClarity}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Table")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltTable + "%"}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Polish")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtPolish}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Crown")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltCrown}
                                    </span>
                                  </p>
                                  <p style={{ display: 'flex', alignItems: 'center' }}>
                                    <span className="head__txt" style={{ width: '40%' }}>
                                      {t("Lab")}:
                                    </span>
                                    <span className="val__txt" style={{ width: '60%', display: 'flex', alignItems: 'flex-start', gap: '10px', flexDirection: 'column' }}>
                                      {selectedRowDetails.certificateNo && (
                                        <span>{selectedRowDetails.certificateNo}{" "}</span>
                                      )}
                                      <span style={{ display: 'flex', gap: '10px', alignItems: 'center', flexWrap: "wrap" }}>
                                        {selectedRowDetails.certificateImage && (
                                          <img
                                            src={ImageIcon}
                                            alt=""
                                            title="View Certificate Image"
                                            style={{
                                              width: "18px",
                                              height: "18px",
                                              cursor: "pointer",
                                            }}
                                            onClick={() =>
                                              window.open(
                                                selectedRowDetails.certificateImage,
                                                "_blank"
                                              )
                                            }
                                          />
                                        )}
                                        <span
                                          className="linkText"
                                          onClick={() => handleCertificateOpen(selectedRowDetails)}
                                        >
                                          {selectedRowDetails.txtCertificate}
                                        </span>
                                      </span>
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Matched Pair Stock")}#:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.fltCrown}
                                    </span>
                                  </p>
                                </div>

                                <div
                                  style={{
                                    flex: 1,
                                    borderLeft: "1px solid #ccc",
                                    paddingLeft: "20px",
                                    backgroundColor: "#f5f5f5",
                                  }}
                                >
                                  <p>
                                    <span className="head__txt">
                                      {t("Seller")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.dealerCompany}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Stock")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.txtStockNo}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Phone")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.dealerPhone}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Location")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.dealerLocation}
                                    </span>
                                  </p>
                                  <p>
                                    <span className="head__txt">
                                      {t("Updated")}:
                                    </span>{" "}
                                    <span className="val__txt">
                                      {selectedRowDetails.modified}
                                    </span>
                                  </p>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
                {/* View DiamondImage Modal */}

                <Modal
                  title=""
                  visible={isModalVisibleFullscreen}
                  className="fullscreen__modal image-modal"
                  onCancel={handleCancelFullscreen}
                  footer={false}
                  width={500}
                //style={{ top: 30 }}
                >
                  <div className="thimage__slider text-center">
                    <img
                      src={
                        selectedRowDetails?.imageBigShape
                          ? selectedRowDetails?.imageBigShape
                          : selectedRowDetails?.imageFileName
                          ? selectedRowDetails?.imageFileName
                          : ""
                      }
                      alt=""
                      className="img-fluid"
                      height={"400px"}
                      width="300"
                    />
                  </div>
                </Modal>
                {/* Message Send Modal */}
                <Modal
                  title={
                    <React.Fragment>
                      <h4 className="d-flex mb-0">
                        {t("Message to")}
                        <h4 className="linkTextWithoutPointer mx-2 mb-0">
                          {selectedDealer ? selectedDealer : ""}
                        </h4>
                      </h4>
                    </React.Fragment>
                  }
                  className="modalvdiamond__section"
                  centered
                  visible={visible1}
                  onOk={() => setVisible1(false)}
                  onCancel={() => setVisible1(false)}
                  width={600}
                  footer={[
                    <Button key="back" onClick={handleCancel1}>
                      {t("Cancel")}
                    </Button>,
                    <Button
                      key="submit"
                      type="primary"
                      onClick={handleMsgValidation}
                      loading={msgLoading}
                    >
                      {t("Send")}
                    </Button>,
                  ]}
                >
                  <Spin spinning={companyLogoLoading}>
                    <div className="col-lg-12">
                      <div className="modal__body">
                        <div className="col-lg-12">
                          <div className="form__fields border-0 p-0">
                            <div className="row">
                              <div className="col-lg-12">
                                <p>
                                  {t("Contact the dealer regarding")}.{" "}
                                  <span className="linkTextWithoutPointer">
                                    {selectedRowDetails.txtStockNo} .
                                  </span>
                                </p>
                              </div>
                              <div className="col-lg-12">
                                <div class="input__block">
                                  <textarea
                                    id=""
                                    name=""
                                    rows="6"
                                    cols="50"
                                    placeholder={t(
                                      "Write your message here..."
                                    )}
                                    class=""
                                    value={msgData}
                                    onChange={(e) => {
                                      setMsgData(e.target.value);
                                      setMsgError("");
                                    }}
                                  ></textarea>
                                  {msgError ? (
                                    <div className="text-danger">
                                      {msgError}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </Spin>
                </Modal>
                {/* Video and Image View Modal */}
                <Modal
                  title={t("Video/Images")}
                  className="modalconsupld__section"
                  centered
                  width={(() => {
                    if (isVideo && selectedRowDetails.videoFileName) {
                      const videoUrl = selectedRowDetails.videoFileName.toLowerCase();
                      const urlPath = videoUrl.split('?')[0];
                      const isDirectVideo = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.wmv'].some(ext => urlPath.endsWith(ext));
                      // Wider modal for embedded videos (YouTube, Vimeo, etc.), narrower for direct video files
                      return isDirectVideo ? 600 : 900;
                    }
                    // Wider modal for images
                    return selectedRowDetails.imageFileName ? 700 : 450;
                  })()}
                  style={{ zIndex: "1000" }}
                  visible={videoImageModal}
                  onCancel={() => handleCloseVideoImageModal()}
                  footer={[
                    <Button onClick={() => handleCloseVideoImageModal()}>
                      {t("Cancel")}
                    </Button>,
                  ]}
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          <div className="row">
                            {isVideo ? (
                              selectedRowDetails.videoFileName ? (
                                (() => {
                                  const videoUrl = selectedRowDetails.videoFileName.toLowerCase();
                                  const urlPath = videoUrl.split('?')[0];
                                  // Check if it's a direct video file (mp4, webm, ogg, mov, etc.)
                                  const isDirectVideo = ['.mp4', '.webm', '.ogg', '.mov', '.avi', '.mkv', '.flv', '.wmv'].some(ext => urlPath.endsWith(ext));
                                  // Dynamic height based on video type: embedded videos (16:9), direct files (auto)
                                  const iframeHeight = isDirectVideo ? "auto" : "500px";
                                  return !isDirectVideo ? (
                                    <iframe
                                      src={selectedRowDetails.videoFileName}
                                      height={iframeHeight}
                                      width="100%"
                                      title="diamond-video"
                                      style={{ aspectRatio: "16/9" }}
                                    ></iframe>
                                  ) : (
                                    <video
                                      title="diamond-video"
                                      className="VideoIframe"
                                      src={selectedRowDetails.videoFileName}
                                      controls
                                      id="product_video"
                                      style={{ width: "100%", height: "auto" }}
                                    ></video>
                                  );
                                })()
                              ) : (
                                <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                              )
                            ) : selectedRowDetails.imageFileName ? (
                              <img
                                src={selectedRowDetails.imageFileName}
                                alt="img-diamond"
                                style={{ width: "100%", height: "auto", maxHeight: "600px" }}
                              />
                            ) : (
                              <Empty image={Empty.PRESENTED_IMAGE_SIMPLE} />
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>

                {/* Modal Request Certifiacate  */}

                <Modal
                  title={t("Request Diamond Certificate")}
                  visible={requestCertModal}
                  style={{ top: 70 }}
                  className="request_info"
                  onCancel={closeCertInfoModal}
                  footer={[
                    <Button key="back" onClick={closeCertInfoModal}>
                      {t("Cancel")}
                    </Button>,
                    <Button
                      key="submit"
                      loading={requestCertModalLoading}
                      type="primary"
                      onClick={handleSubmitRequestCert}
                    >
                      {t("Request")}
                    </Button>,
                  ]}
                >
                  <div className="row">
                    <div class="col-md-12">
                      <div className="table__block">
                        <div className="row p-0 border-0 form__fields mh-auto">
                          <div className="col-md-6">
                            <div className="input__block">
                              <label>
                                {t("Name")} <span className="mandatory">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                value={certInfoData.name}
                                className={
                                  certInfoValidation.nameVal && "border__red"
                                }
                                onChange={(e) =>
                                  handleCertInfoChange(e, "name", "input")
                                }
                              />
                              {certInfoValidation.nameVal && (
                                <p className="error-color-red">
                                  {certInfoValidation.nameVal}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input__block">
                              <label>
                                {t("E-Mail Address")}{" "}
                                <span className="mandatory">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                value={certInfoData.email}
                                className={
                                  certInfoValidation.emailVal && "border__red"
                                }
                                onChange={(e) =>
                                  handleCertInfoChange(e, "email", "input")
                                }
                              />
                              {certInfoValidation.emailVal && (
                                <p className="error-color-red">
                                  {certInfoValidation.emailVal}
                                </p>
                              )}
                            </div>
                          </div>
                          <div className="col-md-6">
                            <div className="input__block">
                              <label>
                                {t("Phone Number")}{" "}
                                <span className="mandatory">*</span>{" "}
                              </label>
                              <input
                                type="text"
                                value={certInfoData.phoneNumber}
                                className={
                                  certInfoValidation.phoneNumberVal &&
                                  "border__red"
                                }
                                onChange={(e) =>
                                  handleCertInfoChange(
                                    e,
                                    "phoneNumber",
                                    "input"
                                  )
                                }
                              />
                              {certInfoValidation.phoneNumberVal && (
                                <p className="error-color-red">
                                  {certInfoValidation.phoneNumberVal}
                                </p>
                              )}
                            </div>
                          </div>

                          <div className="col-md-12">
                            <div className="input__block">
                              <label>{t("Comments")}</label>
                              <textarea
                                value={certInfoData.comments}
                                onChange={(e) =>
                                  handleCertInfoChange(e, "comments", "input")
                                }
                              ></textarea>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>

                {/* End */}

                {/* Image zoom modal */}
                <Modal
                  title={isEmail ? "Email Diamond Certificate" : "Image"}
                  className="modalvdiamond__section image__zoommodal"
                  centered
                  visible={visible3}
                  onOk={() => setVisible3(false)}
                  onCancel={() => setVisible3(false)}
                  width={600}
                  footer={
                    isEmail
                      ? null
                      : [
                        <Button key="back"> {t("Print")} </Button>,
                        <Button
                          key="submit"
                          type="primary"
                          onClick={handleOpenIsEmail}
                        >
                          {t("Email")}
                        </Button>,
                      ]
                  }
                >
                  <div className="col-lg-12">
                    <div className="modal__body">
                      <div className="col-lg-12">
                        <div className="form__fields border-0 p-0">
                          {isEmail ? (
                            <React.Fragment>
                              <div className="row">
                                <div className="col-lg-12 ">
                                  <label> {t("Name")}: </label>
                                  <input
                                    type={"text"}
                                    name="Name"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.Name}
                                  />
                                  {errorEmailCertificat.Name ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["Name"]}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12 ">
                                  <label> {t("Email")}: </label>
                                  <input
                                    type={"text"}
                                    name="Email"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.Email}
                                  />
                                  {errorEmailCertificat.Email ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["Email"]}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12 ">
                                  <label> {t("Friend's Name")}: </label>
                                  <input
                                    type={"text"}
                                    name="FriendsName"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.FriendsName}
                                  />
                                  {errorEmailCertificat.FriendsName ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["FriendsName"]}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12 ">
                                  <label> {t("Friend's Email")}: </label>
                                  <input
                                    type={"text"}
                                    name="FriendsEmail"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.FriendsEmail}
                                  />
                                  {errorEmailCertificat.FriendsEmail ? (
                                    <div className="text-danger">
                                      {errorEmailCertificat["FriendsEmail"]}
                                    </div>
                                  ) : null}
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12 ">
                                  <label> {t("Comments")}: </label>
                                  <input
                                    type={"text"}
                                    name="Comments"
                                    onChange={(e) =>
                                      handleEmailCertificatChange(e)
                                    }
                                    value={emailCertificat.Comments}
                                  />
                                </div>
                              </div>
                              <div className="row">
                                <div className="col-lg-12 ">
                                  <Button
                                    type={"primary"}
                                    loading={EmailLoading}
                                    onClick={() => handleCertificateEmailSend()}
                                  >
                                    {t("Submit")}
                                  </Button>
                                  <Button onClick={handleCloseIsEmail}>
                                    {t("Cancel")}
                                  </Button>
                                </div>
                              </div>
                            </React.Fragment>
                          ) : (
                            <div className="row">
                              <div className="col-lg-12 mt-4">
                                <div className="image__zoom">
                                  <img
                                    src={selectedRowDetails.imageFileName}
                                    alt="cer-img"
                                  />
                                </div>
                              </div>
                            </div>
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                </Modal>
              </div>
            </div>
          </div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default ColorStoneSearch;
